import { API } from "./api";

const CID_KEY = "gr_cid";
const CONSENT_KEY = "gr_consent";

function cid() {
  let v = localStorage.getItem(CID_KEY);
  if (!v) { v = (crypto.randomUUID?.() || String(Math.random()).slice(2)) + Date.now().toString(36); localStorage.setItem(CID_KEY, v); }
  return v;
}

export const hasConsent = () => localStorage.getItem(CONSENT_KEY) === "yes";

let gaLoaded = false;
// Carica gtag.js SOLO dopo consenso esplicito: prima nessuna connessione a Google.
export function loadGA4() {
  if (gaLoaded) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=G-G90F2W9B4B";
  document.head.appendChild(s);
  window.gtag?.("js", new Date());
  window.gtag?.("config", "G-G90F2W9B4B", { send_page_view: false });
}

export const setConsent = (ok) => {
  localStorage.setItem(CONSENT_KEY, ok ? "yes" : "no");
  // Nessuna pubblicità su questo sito: si concede solo analytics_storage
  window.gtag?.("consent", "update", { analytics_storage: ok ? "granted" : "denied" });
  if (ok) loadGA4();
};

// All'avvio: carica GA4 solo per i visitatori di ritorno che hanno già accettato
export function initGaConsent() {
  if (hasConsent()) loadGA4();
}

// GA4 page_view per SPA (lo storage cookie è governato dal Consent Mode)
export function gaPageView(path) {
  window.gtag?.("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
}

function channel() {
  const p = new URLSearchParams(window.location.search);
  const utm = p.get("utm_source");
  if (utm) return utm.toLowerCase();
  const r = document.referrer || "";
  if (!r) return "direct";
  const h = (() => { try { return new URL(r).hostname; } catch { return ""; } })();
  if (h.includes("linkedin")) return "linkedin";
  if (h.includes("google")) return "google_organic";
  if (h.includes(window.location.hostname)) return "internal";
  return h ? "referral" : "direct";
}

export function track(type, extra = {}) {
  if (!hasConsent()) return;
  const body = { type, path: window.location.pathname, channel: channel(), cid: cid(), ...extra };
  try {
    navigator.sendBeacon?.(`${API}/events`, new Blob([JSON.stringify(body)], { type: "application/json" }))
      || fetch(`${API}/events`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), keepalive: true });
  } catch { /* noop */ }
}
